"use client";

import { useEffect, useRef } from "react";
import { LoaderCircle } from "lucide-react";
import Session from "supertokens-auth-react/recipe/session";
import {
  buildLoginPath,
  REFRESH_ATTEMPT_COOKIE,
  REFRESH_ATTEMPT_MAX_AGE_SECONDS,
} from "@workspace/core/auth/redirect";

/**
 * O SSR recebeu 401 — normalmente o access token venceu enquanto a aba estava
 * parada. So o SDK do navegador consegue usar o refresh token, entao a renovacao
 * acontece aqui e o usuario volta para a mesma URL sem passar pelo login.
 */
export default function RefreshSessionPage({
  redirectTo,
}: {
  redirectTo: string;
}) {
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const goToLogin = () => window.location.replace(buildLoginPath(redirectTo));

    Session.attemptRefreshingSession()
      .then((refreshed) => {
        if (!refreshed) return goToLogin();
        // Se o SSR recusar de novo logo em seguida, o guard le este marcador e
        // vai ao login em vez de voltar para ca.
        document.cookie = `${REFRESH_ATTEMPT_COOKIE}=1; Path=/; Max-Age=${REFRESH_ATTEMPT_MAX_AGE_SECONDS}; SameSite=Lax`;
        // Navegacao completa: o SSR precisa rodar de novo com o cookie renovado.
        window.location.replace(redirectTo);
      })
      .catch(goToLogin);
  }, [redirectTo]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
      <p
        role="status"
        aria-live="polite"
        className="flex items-center gap-2 text-sm text-muted-foreground"
      >
        <LoaderCircle className="size-4 animate-spin" aria-hidden="true" />
        Restaurando sua sessão...
      </p>
    </main>
  );
}
